import { useParams } from "react-router";

import { GaiaLoadingHelperV2 } from "~/modules/app/components/GaiaLoadingHelperV2";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import { FieldworkerFeedback } from "./FieldworkerFeedback";
import { usePlannerVisitWorkerReport } from "./usePlannerVisitWorkerReport";

export function FieldworkerFeedbackBreadcrumb(match: { params: { reportId: string } }) {
    const { data } = usePlannerVisitWorkerReport(match.params.reportId);
    return data?.plannerVisit.plannerArea.name;
}

export function FieldworkerFeedbackScreen() {
    const { reportId } = useParams<string>();
    if (reportId === undefined) throw new Error("Param `reportId` not available");

    const { data, loading, error } = usePlannerVisitWorkerReport(reportId);

    return (
        <GaiaPageLayoutColumn>
            <GaiaLoadingHelperV2
                data={data}
                error={error}
                loading={loading}
                render={retVal => <FieldworkerFeedback data={retVal} />}
            />
        </GaiaPageLayoutColumn>
    );
}
